import { setTotalCartItems } from "@src/store/slices/configSlice"
import { updateTotalCartItems } from "@src/store/slices/userSlice"
import { store } from "@src/store/store"

type CartLike = {
  products?: unknown[] | null
  total_cart_items?: number | null
} | null | undefined

export const getCartItemCount = (cart: CartLike): number => {
  if (typeof cart?.total_cart_items === "number") {
    return Math.max(0, cart.total_cart_items)
  }
  return Array.isArray(cart?.products) ? cart.products.length : 0
}

/** Keep header badge in sync after cart mutations / fetches. */
export const syncCartItemCount = (cartOrCount: CartLike | number) => {
  const count =
    typeof cartOrCount === "number"
      ? Math.max(0, cartOrCount || 0)
      : getCartItemCount(cartOrCount)

  store.dispatch(setTotalCartItems(count))
  store.dispatch(updateTotalCartItems(count))
}
